import BaseService from './base.service'

const SETTING_JSON = process.env.VUE_APP_SETTING_JSON || ''

/**
 * Extra 7 Boost — FreeBet coupon scan/redeem (retail endpoints).
 *
 * validate: scan a coupon → remaining tickets / amount / expiry / status.
 * redeem:   link the Boost bets placed for this coupon and decrement quantity.
 *
 * Endpoints live on the retail host (same base as /api/retail/*).
 */
class CouponService extends BaseService {
    private baseUrl(): string {
        const settings = JSON.parse(SETTING_JSON || '{}')
        return settings.url
    }

    async validate(code: string) {
        return await this.post(`${this.baseUrl()}/api/retail/coupon/validate`, { code }).then(({ data }) => data)
    }

    async redeem(code: string, bets: string[]) {
        return await this.post(`${this.baseUrl()}/api/retail/coupon/redeem`, { code, bets }).then(({ data }) => data)
    }

    async markPrinted(code: string) {
        return await this.post(`${this.baseUrl()}/api/retail/coupon/printed`, { code }).then(({ data }) => data)
    }
}

export default new CouponService()
